import api from './api/axiosConfig';

const statisticsService = {
  // Get platform statistics
  getPlatformStats: async () => {
    try {
      const response = await api.get('/analytics/platform-stats/');
      return response.data;
    } catch (error) {
      console.error('Error fetching platform statistics:', error);
      throw error;
    }
  },

  // Get admin dashboard data
  getAdminDashboard: async () => {
    try {
      const response = await api.get('/analytics/admin-dashboard/');
      return response.data;
    } catch (error) {
      console.error('Error fetching admin dashboard:', error);
      throw error;
    }
  }
};

export default statisticsService;
